import { TYPES } from '../../render/constants';

export function renderSizeLabel(context, node, region) {
  // Improved text styling
  context.font = 'bold 20px Inter, Arial, sans-serif';
  context.textAlign = 'center';
  context.textBaseline = 'middle';

  const labelText = `${Math.round(node.w)}x${Math.round(node.h)}`;
  const labelX = region.center.x;
  const labelY = region.bottomLeft.y + 48; // Slightly increased distance from bottom

  // Improved background styling
  const textMetrics = context.measureText(labelText);
  const paddingX = 8; // Increased padding
  const paddingY = 4; // Increased padding
  const bgWidth = textMetrics.width + paddingX * 2;
  const bgHeight = 28 + paddingY * 2;
  const cornerRadius = 12; // Larger rounded corners

  // Background with subtle shadow
  context.shadowColor = 'rgba(0, 0, 0, 0.1)';
  context.shadowBlur = 4;
  context.shadowOffsetY = 2;

  context.fillStyle = '#8b3eff'; // More opaque background
  context.beginPath();
  context.moveTo(labelX - bgWidth / 2 + cornerRadius, labelY - bgHeight / 2);
  context.arcTo(
    labelX + bgWidth / 2,
    labelY - bgHeight / 2,
    labelX + bgWidth / 2,
    labelY + bgHeight / 2,
    cornerRadius,
  );
  context.arcTo(
    labelX + bgWidth / 2,
    labelY + bgHeight / 2,
    labelX - bgWidth / 2,
    labelY + bgHeight / 2,
    cornerRadius,
  );
  context.arcTo(
    labelX - bgWidth / 2,
    labelY + bgHeight / 2,
    labelX - bgWidth / 2,
    labelY - bgHeight / 2,
    cornerRadius,
  );
  context.arcTo(
    labelX - bgWidth / 2,
    labelY - bgHeight / 2,
    labelX + bgWidth / 2,
    labelY - bgHeight / 2,
    cornerRadius,
  );
  context.closePath();
  context.fill();

  // Reset shadow for text
  context.shadowColor = 'transparent';
  context.shadowBlur = 0;
  context.shadowOffsetY = 0;

  // Text with subtle shadow
  context.fillStyle = '#fff';
  context.fillText(labelText, labelX, labelY + 2);
}

export function drawRegion(context, stageContext, region) {
  const { scale } = stageContext.providers;

  const pointer = region.transform(scale.scale, scale.translateX, scale.translateY);

  context.beginPath();
  context.rect(pointer.x, pointer.y, pointer.w, pointer.h);
  context.fillStyle = 'rgba(255, 0, 0 ,0.5)';
  context.fill();
  context.strokeStyle = 'black';
  context.lineWidth = 1;
  context.stroke();
}

export function renderInteractiveNodeBorder(
  renderContext,
  context,
  node,
  labelSize,
  { lineWidth = 4 } = {},
) {
  const { scale } = renderContext.providers;
  const region = renderContext.api
    .getNodeRegion(node)
    .transform(scale.scale, scale.translateX, scale.translateY);

  context.strokeStyle = '#8b3eff';
  context.lineWidth = lineWidth;

  context.beginPath();
  context.moveTo(region.topLeft.x, region.topLeft.y);
  context.lineTo(region.topRight.x, region.topRight.y);
  context.lineTo(region.bottomRight.x, region.bottomRight.y);
  context.lineTo(region.bottomLeft.x, region.bottomLeft.y);
  context.lineTo(region.topLeft.x, region.topLeft.y);
  context.closePath();
  context.stroke();
  context.strokeStyle = '';

  if (node.type === TYPES.frame && labelSize) renderSizeLabel(context, node, region);
}

export function drawRectRegion(
  context,
  rect,
  { fill = 'rgba(0, 0, 255, 0.2)', lineWidth = 4, stroke = '#8b3eff' } = {},
) {
  const startX = rect.x;
  const startY = rect.y;

  const width = rect.w;
  const height = rect.h;

  context.strokeStyle = stroke;
  context.lineWidth = lineWidth;
  context.fillStyle = fill;

  context.beginPath();
  context.rect(startX, startY, width, height);
  context.fill();
  context.stroke();
}
